export const KeapApi = ()=>{
    document.location.href= `${process.env.REACT_APP_EXTERNAL_API_URL}/keap/authorize`
    return null;
}